var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    stroke: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6380",
    "data-name": "Rectangle 6380",
    width: 52,
    height: 52,
    transform: "translate(-20017 -4819)",
    fill: "#FF6B5B",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_16286",
    "data-name": "Groupe de masques 16286",
    transform: "translate(20017 4819)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "france",
    transform: "translate(-20017.732 -4820.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11734",
    "data-name": "Trac\\xE9 11734",
    d: "M20.772,13.207a.492.492,0,0,0,.189-.377l.094-2,4.962-2.4a.531.531,0,0,0,.283-.377l.415-2.094A.518.518,0,1,0,25.7,5.773l-.358,1.849-5.019,2.415a.533.533,0,0,0-.3.453l-.075,1.736-4.075-.585-1.189-1.453a.516.516,0,0,0-.736-.075l-1.623,1.3a.537.537,0,0,0-.17.547L13.3,16.244l-3.849.547L7.924,14.98a.494.494,0,0,0-.566-.151L1.094,16.942a.51.51,0,0,0-.321.3.5.5,0,0,0,.019.434l2.415,4.547a.546.546,0,0,0,.208.208l7.622,4.056,3.773,6.792L13.735,45.544l-1.4,1.49a.525.525,0,0,0-.132.434.545.545,0,0,0,.264.377l5.641,3.019a.522.522,0,0,0,.245.057h7.566a.528.528,0,1,0,0-1.057H18.546L13.6,47.223l1.057-1.113a.486.486,0,0,0,.132-.3l1.113-12.6a.854.854,0,0,0-.057-.3L11.9,25.847a.548.548,0,0,0-.208-.208L4.075,21.584,2.019,17.735l5.339-1.811,1.49,1.755a.5.5,0,0,0,.472.17l4.736-.7a.521.521,0,0,0,.358-.226.553.553,0,0,0,.075-.415L13.263,12l.943-.774.981,1.207a.564.564,0,0,0,.321.189l4.849.7a.562.562,0,0,0,.415-.113Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11735",
    "data-name": "Trac\\xE9 11735",
    d: "M52.393,14.339l-8.207-3.132-3.943-1.189L35.092,5.754c-.019-.019-.038-.038-.057-.038l-3.943-2.4-.358-1.7a.57.57,0,0,0-.264-.358.5.5,0,0,0-.434-.019l-3.49,1.4a.52.52,0,1,0,.4.962l2.905-1.17.283,1.3a.554.554,0,0,0,.245.34L34.47,6.584l5.207,4.32a.59.59,0,0,0,.189.094l4,1.189,7.716,2.962L49.45,22.433l-.6.3a.59.59,0,0,0-.208.17L43.3,30.979a.51.51,0,0,0,.038.623.56.56,0,0,0,.6.151l2.49-1.075,1.547,5.151-1.736,1.3a.524.524,0,0,0-.151.641l2.528,5.452a.537.537,0,0,0,.472.3.5.5,0,0,0,.226-.057.51.51,0,0,0,.245-.7l-2.339-5.056L48.9,36.451a.542.542,0,0,0,.189-.566L47.28,29.828A.483.483,0,0,0,47,29.508a.575.575,0,0,0-.434,0l-1.415.623,4.3-6.49.679-.34a.5.5,0,0,0,.264-.321l2.321-7.962a.557.557,0,0,0-.321-.679Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11736",
    "data-name": "Trac\\xE9 11736",
    d: "M48.827,45.224l-4.641,2.622L36.13,45.393a.552.552,0,0,0-.453.075l-3.528,2.415a.5.5,0,0,0-.226.434V51.94H27.508a.527.527,0,0,0-.528.528.516.516,0,0,0,.528.528h4.943a.527.527,0,0,0,.528-.528V48.6l3.094-2.132,8.037,2.453a.634.634,0,0,0,.415-.038l4.849-2.717a.54.54,0,0,0,.208-.717.6.6,0,0,0-.755-.226Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11737",
    "data-name": "Trac\\xE9 11737",
    d: "M17.772,36.243l.208-2.6a.521.521,0,0,0-1.038-.094l-.208,2.6a.538.538,0,0,0,.472.566h.038a.492.492,0,0,0,.528-.472Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11738",
    "data-name": "Trac\\xE9 11738",
    d: "M16.565,38.281l-.585,7.358a.538.538,0,0,0,.472.566h.038A.513.513,0,0,0,17,45.733l.585-7.358a.538.538,0,0,0-.472-.566.52.52,0,0,0-.547.472Z",
    fill: "#FF6B5B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/france.02c3d58bd0104eb434863a5f81f8a962.svg";
export { ForwardRef as ReactComponent };